import { useEffect, useState } from "react";
import { axios } from "../constants/api";
import {
  PurchaseOptionApiResponse,
  PurchaseOptionData,
} from "../../pages/purchase-option/purchase-option.type";

export const usePurchaseOption = (purchaseOptionId?: string) => {
  const [data, setData] = useState<PurchaseOptionData | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!purchaseOptionId) {
      setIsLoading(false);
      return;
    }

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get<PurchaseOptionApiResponse>(
          `/purchase-options/${purchaseOptionId}`
        );

        if (response.data && response.data.success) {
          setData(response.data.data);
          setError(null);
        } else {
          throw new Error(response.data.message || "Failed to fetch data");
        }
      } catch (err: any) {
        setError(err);
        setData(undefined);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [purchaseOptionId]);

  return { data, isLoading, error };
};
